// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"0c74412d","180":"6cbd84cc","208":"08ff5899","631":"80de36d6","774":"c93b8ea6","787":"763aa7e2","820":"e42d823e","851":"acfde190"}[chunkId] + ".chunk.js";
};